module.exports = __webpack_public_path__ + "static/media/parallel_docs.0220303d.md";


//////////////////
// WEBPACK FOOTER
// ./src/examples/parallel/parallel_docs.md
// module id = 997
// module chunks = 0